import React, { useEffect, useState } from 'react';
import TagList from '@Shared.Angular/flowingly.components/TagList/TagList';
import ITagGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagGroupDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import { getService } from '@Client/runner.hooks/useService';

export type Props = {
  tagIds?: Guid[];
};

const FlowTags = ({ tagIds }: Props) => {
  const tagGroupApiService = getService('tagGroupApiService');
  const pubsubService = getService('pubsubService');
  const subscriberId = 'flowTagsComponent';

  const [tagGroups, setTagGroups] = useState<ITagGroupDetail[]>([]);

  useEffect(() => {
    getTagGroups();
    pubsubService.subscribeLate(
      'TAG_GROUP_DELETED',
      getTagGroups,
      subscriberId
    );
    pubsubService.subscribeLate(
      'TAG_GROUP_CREATED',
      getTagGroups,
      subscriberId
    );
    pubsubService.subscribeLate(
      'TAG_GROUP_UPDATED',
      getTagGroups,
      subscriberId
    );
    return () => {
      pubsubService.unsubscribeAll(subscriberId);
    };
  }, []);

  const getTagGroups = () => {
    tagGroupApiService.getAllTagGroups().then((newTagGroups) => {
      setTagGroups(newTagGroups);
    });
  };

  const ids = tagIds || [];
  const tagsByGroupName = tagGroups.reduce<
    Record<string, { tagNames: string[]; color: string }>
  >((acc, group) => {
    const matched = group.tags.filter((tag) => ids.includes(tag.id));
    if (matched.length > 0) {
      acc[group.name] = {
        tagNames: matched.map((t) => t.name),
        color: group.color
      };
    }
    return acc;
  }, {});

  return (
    <div className="runner-flow-tags-container">
      <div>
        <TagList tagsByGroupName={tagsByGroupName} />
      </div>
    </div>
  );
};

export default FlowTags;
